module.exports = __webpack_public_path__ + "img/no-image.f3198d14.png";